import Service from "../Service";
const resource = "paymentcategory/";

export default {
  save(prd, requestID) {
    return Service.post(resource + "save", prd, { params: { requestID: requestID }, });
  },

  pagination(parameters, requestID) {
    console.log("parametro", parameters);
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },

  searchPaymentCategoryByID(CtgID, requestID) {
    return Service.post(resource + "paymentCategoryByID", {}, {
      params: { CtgID: CtgID, requestID: requestID },
    });
  },

  //pdf
};
